import api from './';
import { AxiosResponse } from 'axios';
import { FavoriteTarget, UserFavorite } from './types/favorite';

const fetchFavorites = async () => {
  return await api.get<unknown, AxiosResponse<{ favorites: UserFavorite[] }>>('/users/favorites');
};

const createFavorite = async (target: FavoriteTarget) => {
  return await api.post<FavoriteTarget, AxiosResponse<{ favorite: UserFavorite }>>(
    '/users/favorites',
    target
  );
};

const updateFavorite = async (favoriteId: string, data: { includeChildren: boolean }) => {
  return await api.patch<typeof data, AxiosResponse<{ favorite: UserFavorite }>>(
    `/users/favorites/${favoriteId}`,
    data
  );
};

const deleteFavorite = async (favoriteId: string) => {
  return await api.delete<unknown, AxiosResponse<void>>(`/users/favorites/${favoriteId}`);
};

const reorderFavorites = async (favoriteIds: string[]) => {
  return await api.put<{ favoriteIds: string[] }, AxiosResponse<{ favorites: UserFavorite[] }>>(
    '/users/favorites/order',
    { favoriteIds }
  );
};

const FavoritesApi = {
  fetchFavorites,
  createFavorite,
  updateFavorite,
  deleteFavorite,
  reorderFavorites
};

export default FavoritesApi;
